import { render } from "./EmployeeSpecialties.vue?vue&type=template&id=f5abdfd2&scoped=true"
import script from "./EmployeeSpecialties.vue?vue&type=script&lang=js"
export * from "./EmployeeSpecialties.vue?vue&type=script&lang=js"

import "./EmployeeSpecialties.vue?vue&type=style&index=0&id=f5abdfd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5abdfd2"]])

export default __exports__